/**
 * Route for `mfilterit-integration`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { MfilteritIntegrationPage } from "../features/mfilterit-integration/MfilteritIntegrationPage";

export const mfilteritIntegrationRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/mfilterit-integration",
	component: MfilteritIntegrationPage,
});

export default mfilteritIntegrationRoute;
